require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconPencil.tsx
var IconPencil_exports = {};
__export(IconPencil_exports, {
  default: () => IconPencil_default
});
module.exports = __toCommonJS(IconPencil_exports);

// src/assets/monochrome/pencil.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgPencil = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.7297 3.4333L16.5636 2.26888C15.2031 0.910375 12.9681 0.910375 11.6077 2.26888L2.95919 10.9051C2.47332 11.3902 2.1818 11.9724 1.98745 12.6517L1.30724 15.5628C0.918539 17.4065 2.5705 19.1531 4.41681 18.6679L7.33203 17.9887C8.01225 17.8916 8.5953 17.5035 9.08117 17.0183L17.7297 8.38213C19.0901 7.02363 19.0901 4.7918 17.7297 3.4333ZM6.94333 16.3391L4.0281 17.0183C3.44506 17.1153 2.86202 16.6302 2.95919 15.9509L3.63941 13.0398C3.73659 12.7487 3.83376 12.4576 4.12528 12.1665L7.8179 15.8539C7.52638 16.0479 7.23485 16.242 6.94333 16.3391ZM9.08117 14.5924L5.38855 10.9051L10.3444 5.95623L14.037 9.64359L9.08117 14.5924ZM16.4664 7.2177L15.2031 8.47916L11.5105 4.7918L12.7738 3.53034C13.454 2.85109 14.6201 2.85109 15.3003 3.53034L16.4664 4.69477C17.1466 5.37402 17.1466 6.53845 16.4664 7.2177Z", fill: "#676F7E" }) });
var pencil_default = SvgPencil;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconPencil.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconPencil = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(pencil_default, {}) });
};
IconPencil.displayName = "IconPencil";
var IconPencil_default = IconPencil;
